<template>
  <ValidationObserver @submit="createOrUpdatePostLabelData">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        {{ modalTitle }}
      </template>
      <template v-slot>
        <InputFieldWrapper>
          <InputBox
            v-model="postLabel.title"
            type="text"
            name="LABEL_TITLE"
            title="LABEL_TITLE"
            label="Title"
            placeholder="LABEL_TITLE"
            rules="required|max:15"
          />
          <InputBox
            v-model="postLabel.description"
            type="text"
            name="Description"
            title="Description"
            label="Description"
            placeholder="Description"
          />
        </InputFieldWrapper>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClick('close')">Cancel</UIButton>
          <UIButton type="submit" button="primary">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>
              {{ submitButtonText }}
            </span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import { Form as ValidationObserver } from 'vee-validate'
import UiModalContainer from '@src/components/UiElements/UiModalContainer.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import InputFieldWrapper from '@src/components/UiElements/InputFieldWrapper.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import Loader from '@src/components/BaseComponent/Loader.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AddAndUpdatePostLabels',
  components: {
    ValidationObserver,
    UiModalContainer,
    InputBox,
    InputFieldWrapper,
    UIButton,
    Loader,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Object,
      default: null,
    },
  },
  emits: ['toggle'],
  data() {
    return {
      postLabel: {
        title: '',
        description: '',
      },
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.layout.isLoading,
    }),
    modalTitle() {
      return this.edit ? 'Update Post Label' : 'Add Post Label'
    },
    submitButtonText() {
      return this.edit ? 'Update' : 'Save'
    },
  },
  created() {
    if (this.edit) this.setLabelData(this.edit)
  },
  methods: {
    handleClick(action) {
      if (action === 'close' || action === 'cancel') {
        this.$emit('toggle')
      }
    },
    resetForm() {
      this.postLabel = {
        title: '',
        description: '',
      }
    },

    createOrUpdatePostLabelData() {
      const payload = { postLabel: { ...this.postLabel } }
      if (this.edit) payload.id = this.edit.id

      this.createOrUpdatePostLabel(payload)
        .then(() => {
          this.$emit('toggle', 'success')
        })
        .catch((error) => {
          console.error('Error creating post label:', error)
        })
    },

    setLabelData(label) {
      this.postLabel.title = label.title || ''
      this.postLabel.description = label.description || ''
    },
    ...mapActions('noticeboard', ['createOrUpdatePostLabel']),
  },
}
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-color);
}
</style>
